import { forwardRef } from "react";

import {
  typographyVariants,
  type TypographyVariants,
} from "./typography.styles";

// -----------------------------------------------------------------------------

export type H1Ref = React.ComponentRef<"h1">;

export interface H1Props
  extends React.ComponentPropsWithoutRef<"h1">, TypographyVariants {}

const H1 = forwardRef<H1Ref, H1Props>(
  ({ children, className, palette, size = "h1", ...props }, ref) => {
    return (
      <h1
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </h1>
    );
  },
);

H1.displayName = "H1";

export { H1 };

// -----------------------------------------------------------------------------

export type H2Ref = React.ComponentRef<"h2">;

export interface H2Props
  extends React.ComponentPropsWithoutRef<"h2">, TypographyVariants {}

const H2 = forwardRef<H2Ref, H2Props>(
  ({ children, className, palette, size = "h2", ...props }, ref) => {
    return (
      <h2
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </h2>
    );
  },
);

H2.displayName = "H2";

export { H2 };

// -----------------------------------------------------------------------------

export type H3Ref = React.ComponentRef<"h3">;

export interface H3Props
  extends React.ComponentPropsWithoutRef<"h3">, TypographyVariants {}

const H3 = forwardRef<H3Ref, H3Props>(
  ({ children, className, palette, size = "h3", ...props }, ref) => {
    return (
      <h3
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </h3>
    );
  },
);

H3.displayName = "H3";

export { H3 };

// -----------------------------------------------------------------------------

export type H4Ref = React.ComponentRef<"h4">;

export interface H4Props
  extends React.ComponentPropsWithoutRef<"h4">, TypographyVariants {}

const H4 = forwardRef<H4Ref, H4Props>(
  ({ children, className, palette, size = "h4", ...props }, ref) => {
    return (
      <h4
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </h4>
    );
  },
);

H4.displayName = "H4";

export { H4 };

// -----------------------------------------------------------------------------

export type H5Ref = React.ComponentRef<"h5">;

export interface H5Props
  extends React.ComponentPropsWithoutRef<"h5">, TypographyVariants {}

const H5 = forwardRef<H5Ref, H5Props>(
  ({ children, className, palette, size = "h5", ...props }, ref) => {
    return (
      <h5
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </h5>
    );
  },
);

H5.displayName = "H5";

export { H5 };

// -----------------------------------------------------------------------------

export type H6Ref = React.ComponentRef<"h6">;

export interface H6Props
  extends React.ComponentPropsWithoutRef<"h6">, TypographyVariants {}

const H6 = forwardRef<H6Ref, H6Props>(
  ({ children, className, palette, size = "h6", ...props }, ref) => {
    return (
      <h6
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </h6>
    );
  },
);

H6.displayName = "H6";

export { H6 };

// -----------------------------------------------------------------------------

export type PRef = React.ComponentRef<"p">;

export interface PProps
  extends React.ComponentPropsWithoutRef<"p">, TypographyVariants {}

const P = forwardRef<PRef, PProps>(
  ({ children, className, palette, size = "md", ...props }, ref) => {
    return (
      <p
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </p>
    );
  },
);

P.displayName = "P";

export { P };

// -----------------------------------------------------------------------------

export type SpanRef = React.ComponentRef<"span">;

export interface SpanProps
  extends React.ComponentPropsWithoutRef<"span">, TypographyVariants {}

const Span = forwardRef<SpanRef, SpanProps>(
  ({ children, className, palette, size = "md", ...props }, ref) => {
    return (
      <span
        {...props}
        className={typographyVariants({ className, palette, size })}
        ref={ref}
      >
        {children}
      </span>
    );
  },
);

Span.displayName = "Span";

export { Span };
